module.exports = __webpack_public_path__ + "img/img-avatar02.47c311e4.jpg";